import React from "react";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { HomeOutlined, DesktopOutlined, SettingOutlined } from '@ant-design/icons';
import nemo_logo_ from "../assets/logo-MConverter.eu_.png";
import { mapLocationToMenuKey } from "../utils/generic";
import UserProfileDropdown from "./UserProfileDropdown";

const { Header, Sider, Content } = Layout;

const menuItems = [
  { key: 'home', icon: <HomeOutlined />, label: 'Home' },
  { key: 'devices', icon: <DesktopOutlined />, label: 'Devices' },
  { key: 'settings', icon: <SettingOutlined />, label: 'Settings' },
];

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedKey = mapLocationToMenuKey(location.pathname);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header style={{ background: "#fff", padding: 0, display: 'flex', alignItems: 'center', height: '64px', borderBottom: '1px solid #f0f0f0', boxShadow: '0 1px 6px rgba(0,0,0,0.08)' }}>
        <div style={{ width: 200, minWidth: 200, height: '64px', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 16px' }}>
          <img src={nemo_logo_} alt="cybernemoLogo" style={{ height: '44px', width: 'auto', maxWidth: '168px', objectFit: 'contain' }} />
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}>
          <UserProfileDropdown />
        </div>
      </Header>
      <Layout>
        <Sider width={200}>
          <Menu
            theme="dark"
            selectedKeys={[selectedKey]}
            mode="inline"
            items={menuItems}
            onClick={({ key }) => navigate(`/${key}`)}
          />
        </Sider>
        <Layout>
          <Content style={{ overflow: 'auto' }}>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;